import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useQueryString } from './useQueryString';

const EVENT_PREVIEW_KEY = 'previewEventID';

export const useEventPreview = () => {
  const queryClient = useQueryClient();
  const [eventIdFromUrl, setEventIdInUrl] = useQueryString(EVENT_PREVIEW_KEY, null, true);

  useQuery({
    queryKey: [EVENT_PREVIEW_KEY],
    queryFn: () => eventIdFromUrl,
    initialData: eventIdFromUrl,
  });

  const openEventModal = (id: number) => {
    const idStr = id.toString();
    queryClient.setQueryData([EVENT_PREVIEW_KEY], idStr);
    setEventIdInUrl(idStr);
  };

  const closeEventModal = () => {
    queryClient.setQueryData([EVENT_PREVIEW_KEY], null);
    setEventIdInUrl(undefined);
  };

  const eventId = queryClient.getQueryData<string | null>([EVENT_PREVIEW_KEY]);
  const eventModalIsOpened = !!eventId;

  return { openEventModal, closeEventModal, eventId, eventModalIsOpened };
};
